import { createContext } from 'react';

import ukrainianFlag from '@/assets/icons/language-selector/ukraine.svg';
import usaFlag from '@/assets/icons/language-selector/united-states.svg';
import frenchFlag from '@/assets/icons/language-selector/france.svg';

export interface LanguageOption {
  value: string;
  label: string;
  fullLabel: string;
  flag: string;
}

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  {
    value: 'uk',
    label: 'Укр',
    fullLabel: 'Українська',
    flag: ukrainianFlag,
  },
  {
    value: 'en',
    label: 'Eng',
    fullLabel: 'English',
    flag: usaFlag,
  },
  {
    value: 'fr',
    label: 'Fr',
    fullLabel: 'Français',
    flag: frenchFlag,
  },
];

interface LanguageContextProps {
  selectedLanguage: LanguageOption;
  setLanguage: (lang: LanguageOption) => void;
  languageOptions: LanguageOption[];
}

export const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);
